module.exports = __webpack_public_path__ + "static/rust_1-40b2fc36d81aaa12664da0e00bb1c1fa.jpg";